import { CeremonyForm, CeremonyFormModel } from './CeremonyFormModel';

export interface FormModel {
  ceremonyForm: CeremonyFormModel;
  isLastEventSubmitted: boolean; // 上次event有無參加
  isSubmitted: boolean; // 本次表單有無送出
  submitTime: string; // 送出表單的時間
  signature: string; // 填表的人是哪位
  formId: string;
  streamId: number; // 報名序號, 為大於0的數字 (0代表未設定), 在resetForm之後被設定為0
}

export class Form implements FormModel {
  ceremonyForm: CeremonyFormModel;

  isLastEventSubmitted: boolean;

  isSubmitted: boolean;

  submitTime: string;

  signature: string;

  formId: string;

  streamId = 0;

  constructor() {
    this.ceremonyForm = new CeremonyForm();
    this.isLastEventSubmitted = false;
    this.isSubmitted = false;
    this.submitTime = '';
    this.signature = '';
    this.formId = '';
  }
}
